import React, { useState } from 'react';
import { Outlet, Link, useLocation, useNavigate } from 'react-router-dom';
import { clinicAuthService } from '../services/clinicService';

function ClinicLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const user = clinicAuthService.getUser();
  const [showUserMenu, setShowUserMenu] = useState(false);

  const handleLogout = () => {
    clinicAuthService.logout();
    navigate('/clinic/login');
  };

  const navItems = [
    { name: 'Dashboard', path: '/clinic/dashboard', icon: '📊' },
    { name: 'Appointments', path: '/clinic/appointments', icon: '📅' },
    { name: 'Patients', path: '/clinic/patients', icon: '👥' },
    { name: 'Doctors', path: '/clinic/doctors', icon: '👨‍⚕️' },
    { name: 'Staff', path: '/clinic/staff', icon: '👔' },
    { name: 'Invoices', path: '/clinic/invoices', icon: '💳' },
  ];

  return (
    <div className="min-h-screen bg-gray-100">
      {/* Sidebar */}
      <aside className="fixed top-0 left-0 h-full w-64 bg-gradient-to-b from-green-600 to-blue-600 text-white">
        <div className="p-6">
          <h1 className="text-2xl font-bold">🏥 Clinic Portal</h1>
          <p className="text-sm text-green-100 mt-1">{user?.name}</p>
        </div>

        <nav className="mt-6">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`flex items-center gap-3 px-6 py-3 hover:bg-white hover:bg-opacity-20 transition ${
                location.pathname === item.path ? 'bg-white bg-opacity-20 border-l-4 border-white' : ''
              }`}
            >
              <span className="text-2xl">{item.icon}</span>
              <span>{item.name}</span>
            </Link>
          ))}
        </nav>
      </aside>

      {/* Main Content */}
      <div className="ml-64">
        {/* Top Bar */}
        <header className="bg-white shadow-sm">
          <div className="flex items-center justify-between px-6 py-4">
            <h2 className="text-xl font-semibold text-gray-800">
              {navItems.find((item) => item.path === location.pathname)?.name || 'Dashboard'}
            </h2>

            <div className="relative">
              <button
                onClick={() => setShowUserMenu(!showUserMenu)}
                className="flex items-center gap-3 hover:bg-gray-100 rounded-lg px-4 py-2 transition"
              >
                <div className="w-10 h-10 bg-gradient-to-br from-green-500 to-blue-500 rounded-full flex items-center justify-center text-white font-semibold">
                  {user?.name?.charAt(0)}
                </div>
                <div className="text-left">
                  <p className="text-sm font-semibold">{user?.name}</p>
                  <p className="text-xs text-gray-500 capitalize">{user?.role?.replace('_', ' ')}</p>
                </div>
              </button>

              {showUserMenu && (
                <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg py-2 z-50">
                  <Link
                    to="/clinic/profile"
                    className="block px-4 py-2 hover:bg-gray-100"
                    onClick={() => setShowUserMenu(false)}
                  >
                    Profile Settings
                  </Link>
                  <button
                    onClick={handleLogout}
                    className="block w-full text-left px-4 py-2 hover:bg-gray-100 text-red-600"
                  >
                    Logout
                  </button>
                </div>
              )}
            </div>
          </div>
        </header>

        {/* Page Content */}
        <main className="p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}

export default ClinicLayout;
